export default "__VITE_ASSET__CQuyNjgB__"